export default {
	install(app, options) {
		if (!options || !options.router || !options.i18n) {
			throw new Error('Please initialize plugin with router (options.router) and i18n (options.i18n).');
		}

		options.router.beforeEach((to, from, next) => {
			const routeTitle = options.i18n.t('$global.routes.' + to.name);
			document.title = `${window.__APP_CONFIG__.TITLE} - ${routeTitle}`;

			next();
		});
	},
};
